exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!bootstrap/dist/css/bootstrap.css"), "");

// Module
exports.push([module.id, "\n", ""]);

